
export const getRequestsLabelData = (data) => {
    const info = data?.filter(dataSet => dataSet.Name == "Solicitudes")
    const finalInfo = info[0]?.DataValues?.map((month) => {
        return month.Data
    })

    return finalInfo
}

export const getApprovedValues = (data) => {
    const solicitudes = data?.filter(dataSet => dataSet.Name == "Solicitudes")
    const aprobados = solicitudes[0]?.DataValues?.map((month) => {
        return month?.DataValues?.filter((set) => {
            return set?.Data == "Aprobados"
        })
    })?.reduce((a, b) => [...a, ...b], []);
    if (aprobados === undefined || aprobados === null) {
        return null
    } else {
        const barInfo = {
            label: aprobados[0]?.Data,
            backgroundColor: aprobados[0]?.Color,
            data: aprobados?.map((dat) => {
                return dat.Value
            })
        }

        return barInfo
    }
}

export const getRejectedValues = (data) => {
    const solicitudes = data?.filter(dataSet => dataSet.Name == "Solicitudes")
    const aprobados = solicitudes[0]?.DataValues?.map((month) => {
        return month.DataValues.filter((set) => {
            return set.Data == "Rechazados"
        })
    })?.reduce((a, b) => [...a, ...b], []);
    if (aprobados === undefined || aprobados === null) {
        return null
    } else {
        const barInfo = {
            label: aprobados[0]?.Data,
            backgroundColor: aprobados[0]?.Color,
            data: aprobados?.map((dat) => {
                return dat.Value
            })
        }

        return barInfo
    }
}

export const getHoldValues = (data) => {
    const solicitudes = data?.filter(dataSet => dataSet.Name == "Solicitudes")
    const aprobados = solicitudes[0]?.DataValues?.map((month) => {
        return month.DataValues.filter((set) => {
            return set.Data == "Pendientes"
        })
    })?.reduce((a, b) => [...a, ...b], []);

    if (aprobados === undefined || aprobados === null) {
        return null
    } else {
        const barInfo = {
            label: aprobados[0]?.Data,
            backgroundColor: aprobados[0]?.Color,
            data: aprobados?.map((dat) => {
                return dat.Value
            })
        }

        return barInfo
    }
}

export const getLabelsDoughnutGraph = (data) => {
    const info = data?.filter(dataSet => dataSet.Name == "Estatus")
    const finalInfo = info[0]?.DataValues?.map((month) => {
        return month.Data
    })
    return finalInfo
}

export const getdataDoughnutGraph = (data) => {
    const info = data?.filter(dataSet => dataSet.Name == "Estatus")
    const dataSet = {
        data: info[0]?.DataValues?.map((element) => {
            return element.Value
        }),
        backgroundColor: info[0]?.DataValues?.map((element) => {
            return element.Color
        }),
    }
    return dataSet
}